import { type MouseEvent, MouseEventHandler } from 'react';

/**
 * Prevent the default browser behaviour on an user called event.
 */
export const preventDefault: MouseEventHandler<Element> = (event: MouseEvent<Element>) => {
  event.preventDefault();
  return false;
};

/**
 * Stop the propagation of an (parent) defined event, in order to execute the childEvent.
 * Execute this from the childEvent that gets captured by a parent event.
 */
export const stopPropagation: MouseEventHandler<Element> = (event: MouseEvent<Element>) => {
  event.stopPropagation();
};
